<template>
  <div>
    <list listTitle="Produtos" :listLogo="module.logo" filterTitle="Listagem de produtos" :loading="loading" :total="productsTotal" :sortFields="['createdAt', 'title', 'brand']" :sortDefault="{ field: 'createdAt', order: 'desc' }" @change="onChange" @clearFilters="clearFilters">
      <div slot="top-actions">
        <div class="l-row">
          <div class="l-col-12@md inline-flex">
            <button data-label="Selecionar todos" @click="selectAll()" class="hint hint--right btn btn--lg btn--default">
              <i class="check-box" v-bind:class="selectClass"></i>
            </button>
            <bulk-actions :actions="bulkActions" icon="icon-cloud-upload" @apply="applyBulkAction" @actions="updateActions"/>
          </div>
        </div>
      </div>

      <template slot="filters">
        <form-group label="Código do produto">
          <div class="l-row">
            <div class="l-col-10@md">
              <vue-tags-input
                class="form-input"
                v-model="options.code"
                :tags="productCodes"
                :separators="[',']"
                :add-on-key="[',']"
                placeholder=""
                @tags-changed="newCodes => productCodes = newCodes"/>
            </div>

            <div class="l-col-2@md u-textRight btn-dropdown">
              <button-dropdown :infos="configuresCodeType" defaultOption="contains" @change="(type) => options.codeType = type"/>
            </div>
          </div>
          <small class="form-help">Utilize vírgula (,) para múltiplos códigos.</small>
        </form-group>

        <form-group label="EAN do produto">
          <input class="form-input" v-model="options.ean">
        </form-group>

        <form-group label="Título do produto">
          <input class="form-input" v-model="options.title">
        </form-group>

        <form-group label="Marca">
          <multiselect
            v-model="options.brand"
            :options="brands"
            selectLabel=""
            selectedLabel=""
            :multiple="true"
            placeholder="Todas"
            :close-on-select="false"
          />
          <button type="button" @click="selectAllBrands" class="btn btn--default count-selected hint hint--right" data-label="Selecionar todas Marcas">
            <i class="icon icon-checkbox-checked colorButton"></i>
          </button>
        </form-group>

        <form-group label="Categoria">
          <multiselect
            v-model="options.category"
            :options="categories"
            selectLabel=""
            selectedLabel=""
            placeholder="Selecione"
          />
        </form-group>

        <form-group label="Status">
          <select v-model="options.status" class="form-select">
            <option :value=null>Todos</option>
            <option value="waiting">{{ $t('waiting.label') }}</option>
            <option value="not_synchronized">{{ $t('not_synchronized.label') }}</option>
            <option value="synchronized">{{ $t('synchronized.label') }}</option>
          </select>
        </form-group>

        <form-group label="Enviados">
          <div class="l-row">
            <div class="l-col-10@md">
              <select v-model="options.marketplaceSent" class="form-select">
                <option :value=null>{{ $t('choose.label') }}</option>
                <option v-for="module in optionsMarketplaceSent()" :key="module" :value="module.identifier">{{ module.name }}</option>
              </select>
            </div>

            <div class="l-col-2@md u-textRight btn-dropdown">
              <button-dropdown :infos="configuresSent" defaultOption="partially" @change="(type) => options.marketplaceSentType = type" :disabled="options.marketplaceSent === null" :showHintDisabled="false"/>
            </div>
          </div>
        </form-group>

        <form-group label="Ignorar variações sem imagem">
          <select v-model="options.hasImageInAllVariations" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value=true>Sim</option>
          </select>
        </form-group>

        <form-group label="Ignorar variações sem estoque">
          <select v-model="options.hasStock" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value=true>Sim</option>
          </select>
        </form-group>

        <form-group :label="$t('productGroupedId.label')">
          <input class="form-input" v-model="options.productId">
        </form-group>

        <form-group label="Data de criação">
          <el-date-picker
            v-model="options.createdDate"
            type="datetimerange"
            format="dd/MM/yyyy"
            start-placeholder="Data Inicial"
            end-placeholder="Data Final">
          </el-date-picker>
        </form-group>

        <form-group :label="$t('manufacturerReference.label')">
          <vue-tags-input
            class="form-input"
            v-model="options.manufacturerReference"
            :tags="manufacturerReferenceTags"
            :separators="[',']"
            :add-on-key="[',']"
            placeholder=""
            @tags-changed="newTags => manufacturerReferenceTags = newTags"/>
          <small class="form-help">Utilize vírgula (,) para múltiplas referências.</small>
        </form-group>

      </template>
      <div class="l-col-12@md" v-for="(item, index) in productsItems" :key="index">
        <component :is="productCardComponent" ref="items" :product="item"/>
      </div>
      <div class="l-col u-textCenter" v-if="!productsItems.length">
        <panel>
          Nenhum produto encontrado.
        </panel>
      </div>
    </list>
  </div>
</template>

<script>
  import bulkActionsDI from '@/storage/bulkActions'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge, upperFirst, cloneDeep } from 'lodash'
  import BulkActions from '@/components/shared/BulkActions'
  import FormGroup from '@/components/template/FormGroup'
  import ProductCardMoovin from '@/components/ProductProvide/List/Card/Moovin'
  import ProductCardApi from '@/components/ProductProvide/List/Card/Api'
  import ProductCardTiny from '@/components/ProductProvide/List/Card/Tiny'
  import ProductCardFlexy from '@/components/ProductProvide/List/Card/Flexy'
  import ProductCard from '@/components/ProductProvide/List/Card/Shared'
  import ProductCardOneeg from '@/components/ProductProvide/List/Card/Oneeg'
  import ProductCardEcomece from '@/components/ProductProvide/List/Card/Ecomece'
  import List from '@/components/shared/list/Paginator'
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import Multiselect from 'vue-multiselect'
  import VueTagsInput from '@johmun/vue-tags-input'
  import ButtonDropdown from '@/components/template/ButtonDropdown'

  export default {
    data: () => ({
      isSelectedAllBrands: false,
      loading: false,
      productCodes: [],
      manufacturerReferenceTags: [],
      options: {
        code: '',
        codeType: null,
        title: '',
        brand: null,
        ean: '',
        category: '',
        status: null,
        sortOrder: null,
        marketplaceSent: null,
        marketplaceSentType: null,
        hasImageInAllVariations: null,
        hasStock: null,
        productId: null,
        manufacturerReference: '',
        createdDate: []
      },
      brands: [],
      categories: [],
      selectedAll: false,
      route: null,
      configuresCodeType: {
        label: 'Configuração do filtro de código',
        identifier: 'code-type-configure',
        icon: 'fa fa-cog',
        value: '',
        sizeBtn: '',
        options: [
          'contains',
          'notContain'
        ]
      },
      configuresSent: {
        label: 'Configuração do filtro de enviados',
        identifier: 'marketplace-sent-configure',
        icon: 'fa fa-cog',
        value: '',
        sizeBtn: '',
        options: [
          'partially',
          'totally',
          'none'
        ]
      }
    }),
    props: {
      moduleType: {
        type: String,
        required: true
      },
      moduleIdentifier: {
        type: String,
        required: true
      }
    },
    created () {
      this.clear()
      this.clearSentItems()

      if (this.productsLastFetchOptions) {
        this.options = {...this.productsLastFetchOptions}
      }

      const actualDate = new Date()
      const oldDate = new Date()
      oldDate.setDate(actualDate.getDate() - 15)
      this.options.createdDate.push(oldDate, actualDate)

      this.productCodes = this.productsTags['productCodes'] ? this.productsTags['productCodes'] : []
      this.manufacturerReferenceTags = this.productsTags['manufacturerReferences'] ? this.productsTags['manufacturerReferences'] : []
    },
    updated () {
      const route = this.$router.history.current.path

      if (this.route === route) {
        return
      }

      const mercadoLivreModule = this.definitionMarketplacesInstalled.find(
        marketplaceInstalled => marketplaceInstalled.identifier === 'mercadoLivre'
      )

      if (mercadoLivreModule !== undefined) {
        this.fetchAccounts({
          options: {
            active: true
          }
        })
      }

      api.getBrands(this.moduleType, this.moduleIdentifier)
        .then(brands => { this.brands = brands })
        .catch(() => {
          this.brands = []
          notifier.error('Impossível carregar as marcas.', 'Erro')
        })

      api.getCategories(this.moduleType, this.moduleIdentifier)
        .then(categories => { this.categories = categories })
        .catch(() => {
          this.categories = []
          notifier.error('Impossível carregar as categorias.', 'Erro')
        })

      this.onChange(this.options)

      this.route = route
    },
    methods: {
      ...mapActions('products', [
        'fetch',
        'clearProducts',
        'fillTags',
        'addTag'
      ]),
      ...mapActions('itemsSelected', [
        'clear'
      ]),
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ]),
      ...mapActions('sendAnnouncements', [
        'clearSentItems'
      ]),
      updateActions (actions) {
        this.bulkActions = actions
      },
      onChange (options) {
        if (this.loading) {
          return false
        }

        this.loading = true

        merge(this.options, options)

        const codes = []

        if (this.options.code !== '') {
          codes.push(this.options.code)
        }

        for (let i in this.productCodes) {
          let code = this.productCodes[i]
          if (code.hasOwnProperty('text')) {
            code = code.text
          }

          codes.push(code)
        }

        this.options.code = codes.join(',')

        const manufacturerReferences = []

        if (this.options.manufacturerReference !== '') {
          manufacturerReferences.push(this.options.manufacturerReference)
        }

        for (let i in this.manufacturerReferenceTags) {
          let reference = this.manufacturerReferenceTags[i]
          if (reference.hasOwnProperty('text')) {
            reference = reference.text
          }

          manufacturerReferences.push(reference)
        }

        this.options.manufacturerReference = manufacturerReferences.join(',')

        this.clearProducts()

        this.fillTags({
          productCodes: codes,
          manufacturerReferences: manufacturerReferences
        })

        this.fetch({
          type: this.moduleType,
          identifier: this.moduleIdentifier,
          options: this.options
        })
          .then(() => {})
          .catch(() => {})
          .then(() => {
            this.loading = false
            this.options.code = ''
            this.options.manufacturerReference = ''
          })
      },
      applyBulkAction (action) {
        this.$router.push(`/${action}/${this.moduleType}/${this.moduleIdentifier}`)
      },
      selectAll () {
        this.selectedAll = !this.selectedAll

        for (let i in this.$refs.items) {
          this.$refs.items[i].$children[0].onSelect(this.selectedAll)
        }
      },
      optionsMarketplaceSent () {
        const options = []
        for (let i in this.definitionMarketplacesInstalled) {
          const module = this.definitionMarketplacesInstalled[i]
          if (module.identifier === 'mercadoLivre') {
            for (let j in this.mercadoLivreAccounts) {
              const mercadoLivreAccount = this.mercadoLivreAccounts[j]

              const moduleClone = cloneDeep(module)

              moduleClone.identifier += '-' + mercadoLivreAccount.identifier
              moduleClone.name += ' (' + mercadoLivreAccount.nickname + ')'

              options.push(moduleClone)
            }
            continue
          }
          options.push(module)
        }
        return options
      },
      clearFilters () {
        this.options.code = ''
        this.productCodes = []
        this.options.manufacturerReference = ''
        this.manufacturerReferenceTags = []
      },
      selectAllBrands () {
        if (this.isSelectedAllBrands) {
          this.isSelectedAllBrands = false
          this.options.brand = []
          return
        }
        this.isSelectedAllBrands = true
        this.options.brand = this.brands
      }
    },
    computed: {
      ...mapFields({
        productsTotal: 'products.total',
        productsItems: 'products.items',
        productsLastFetchOptions: 'products.lastFetchOptions',
        productsTags: 'products.tags',
        itemsSelectedTotalSelected: 'itemsSelected.totalSelected',
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType',
        'definitionMarketplacesInstalled'
      ]),
      bulkActions () {
        return bulkActionsDI
      },
      selectClass () {
        return {
          'checked': this.selectedAll
        }
      },
      module () {
        return this.getDefinitionModuleByIdentifierAndType(this.moduleType, this.moduleIdentifier)
      },
      productCardComponent () {
        return `ProductCard${upperFirst(this.moduleIdentifier)}`
      }
    },
    watch: {
      itemsSelectedTotalSelected () {
        this.selectedAll = false
        if (this.productsItems.length) {
          if (this.itemsSelectedTotalSelected === this.productsItems.length) {
            this.selectedAll = true
          }
        }
      }
    },
    components: {
      FormGroup,
      ProductCardMoovin,
      ProductCardApi,
      ProductCardTiny,
      ProductCardFlexy,
      ProductCardOneeg,
      ProductCardEcomece,
      ProductCard,
      BulkActions,
      List,
      Panel,
      Multiselect,
      VueTagsInput,
      ButtonDropdown
    }
  }
</script>

<style scoped lang="sass">
  .logo
    max-height: 30px
    margin-right: 20px

  .title
    margin-top: 16px
    margin-left: 20px

  .paginator
    float: right

  .count-selected
    margin-top: 3px

  .selectAll
    width: 48px
    padding: 16px

  .btn--default
    margin-right: 5px

  .inline-flex
    display: inline-flex

  .check-box
    border-color: #7872ff

  .btn-dropdown
    padding-left: unset

  .colorButton
    color: #7872ff
</style>



// WEBPACK FOOTER //
// List.vue?0b19ed2e